import React, { useRef, useEffect, useState } from 'react';
import "leaflet/dist/leaflet.css";
import 'maplibre-gl/dist/maplibre-gl.css';
import L from "leaflet";
import '@maplibre/maplibre-gl-leaflet';
import '../map.css';
import axios from 'axios';
import Sheet from 'react-modal-sheet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { colors } from '../color';
import { v4 as uuidv4 } from 'uuid';
import { List, AutoSizer, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import { DislikeFilled, LikeFilled, LikeOutlined, DislikeOutlined } from '@ant-design/icons';
import { EnvironmentOutlined, EnvironmentFilled, PlusOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { FaCrosshairs, FaExclamationTriangle, FaTrash } from 'react-icons/fa';
import ErrorComponent from '../component/ErrorComponent';
import { ServerIP } from '../component/ServerIP';
import Loader from '../component/Loader';
import { io } from 'socket.io-client';





const AlertDriverMap = ({ }) => {

    const params = new URLSearchParams(window.location.search);
    const userId = params.get('userId');

    //Map
    const intervalIdRef = useRef(null);
    const mapContainer = useRef(null);
    const map = useRef(null);
    const center = { lat: 18.6565184, lng: -72.3156992 };
    const [location, setLocation] = useState([]);
    const [zoom] = useState(12);

    useEffect(() => {

        if (map.current) return;

        map.current = new L.Map(mapContainer.current, {
            center: L.latLng(center.lat, center.lng),
            zoom: zoom,
            zoomControl: false,
        });

        // Utilisation de MapLibre GL avec Leaflet selon la documentation OpenFreeMap
        L.maplibreGL({
            style: 'https://tiles.openfreemap.org/styles/liberty',
            attribution: '© <a href="https://openfreemap.org/copyright">OpenFreeMap</a> contributors'
        }).addTo(map.current);

        // fetchNearbyMarker();

    }, [center.lng, center.lat, zoom]);


    useEffect(() => {
        if (map.current) {

            const centerMap = map.current.getCenter();

            map.current.on('moveend', () => {
                const centerMap = map.current.getCenter();
                console.log('center', centerMap);
            });

            // Écouteur pour le zoom de la carte
            map.current.on('zoomend', () => {
                const centerMap = map.current.getCenter();
            });
        }

        // Le reste de votre logique...

    }, [center.lng, center.lat, zoom]);



    //Alert

    const [alertMarker, setAlertMarker] = useState([]);
    const [currentMarkerIndex, setCurrentMarkerIndex] = useState(null);
    const [message, setMessage] = useState('')

    const [isOpen, setOpen] = useState(false);
    const [isOpen1, setOpen1] = useState(false);
    const [isOpen2, setOpen2] = useState(false);

    const [commentaryType, setCommentaryType] = useState("Popile");
    const [commentary, setCommentary] = useState("");
    const [isVisible, setIsVisible] = useState(false)
    const [addMarker, setAddMarker] = useState(false)

    const cache = useRef(null);
    const listRef = useRef(null);

    const [marker, setMarker] = useState(null);
    const [markerPos, setMarkerPos] = useState(null);
    const [circle, setCircle] = useState(null);


    const cancelMarkerFunc = () => {
        if (marker) {
            marker.remove();
        } else {
            console.log('No marker to remove');
        }

        if (circle) {
            circle.remove();
        } else {
            console.log('No circle to remove');
        }

        setCircle(null);
        setMarkerPos(null);
        setMarker(null);
        setAddMarker(false);
    };

    const setMarkerFunc = () => {
        let lastValidPosition = null;
        let isMoving = false;


        // Vérifie si un cercle existe déjà
        if (circle) {
            console.log('Circle already exists');
            return;
        }

        if (!location || !location[0] || !location[1]) {
            console.log('Invalid location');
            return;
        }

        const newCircle = L.circle([location[0], location[1]], { radius: 1000, color: colors.accent }).addTo(map.current);

        map.current.flyTo([location[0] - 0.001, location[1] - 0.001]);

        const onMoveEnd = () => {
            if (isMoving) return; // Empêche la récursion infinie
            isMoving = true;

            const centerMap = map.current.getCenter();

            // Vérifie que le cercle existe toujours avant d'appeler getBounds()
            if (newCircle && map.current.hasLayer(newCircle) && newCircle.getBounds().contains(centerMap)) {
                lastValidPosition = centerMap;
                setMarkerPos(lastValidPosition);
            } else {
                if (lastValidPosition && map.current.hasLayer(newCircle)) {
                    map.current.panTo(lastValidPosition);
                    setMarkerPos(lastValidPosition);
                }
            }

            isMoving = false;
        };

        map.current.on('moveend', onMoveEnd);

        setCircle(newCircle);
        setAddMarker(true);

        // Nettoyage de l'événement lorsque le composant est démonté
        return () => {
            map.current.off('moveend', onMoveEnd);
        };
    };


    useEffect(() => {
        if (addMarker) {
            const cleanup = setMarkerFunc();
            return cleanup;
        }
    }, [addMarker]);



    console.log('MarkerPos:', markerPos);
    // console.log('Cercle:', circle);



    const confirmMarkerFunc = () => {
        setOpen1(true);
    }

    const states = ['Tir', 'Kidnapping', 'Blocked'];
    const [selectedState, setSelectedState] = useState('Tir');
    const [description, setDescription] = useState('');

    const confirmAction = async () => {
        try {
            setIsVisible(true)

            if (markerPos !== null) {

                const alertId = uuidv4();

                const alert = {
                    userId: userId,
                    alertId: alertId,
                    title: selectedState,
                    description: description,
                    latitude: markerPos.lat,
                    longitude: markerPos.lng
                }
                console.log(alert)
                
                await axios.post(`${ServerIP}/alert/postAlert`, alert)
                    .then(res => {
                        console.log(res.data)
                        fetchNearbyMarker();
                        closeModal1();
                        cancelMarkerFunc();
                    })
            }

            setIsVisible(false)
        } catch (error) {
            setIsVisible(false)
            console.log(error)
            console.log(error.respone)

            if (error.response) {
                setMessage(error.response.data.message);
            } else {
                setMessage("Il semble qu’il y ait un problème avec le serveur. Veuillez réessayer plus tard.")
            }

        }
    };

    useEffect(() => {

        if (message.length !== 0) {

            const timer = setTimeout(() => {
                setMessage('');
            }, 8000);

            return () => clearTimeout(timer);
        }
    }, [message]);


    function getColor(title) {
        switch (title) {
            case 'Tir':
                return 'rgba(255,0,0,0.5)';
            case 'Kidnapping':
                return 'rgba(230, 126, 34, 0.5)';
            case 'Blocked':
                return 'gray';
            default:
                return 'black';
        }
    }

    function getIcon(title) {
        switch (title) {
            case 'Tir':
                return L.icon({ iconUrl: require('../data/IconImageMap/gun.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            case 'Kidnapping':
                return L.icon({ iconUrl: require('../data/IconImageMap/child.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            case 'Blocked':
                return L.icon({ iconUrl: require('../data/IconImageMap/block1.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            default:
                return L.icon({ iconUrl: require('../data/IconImageMap/block.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
        }
    }

    function getRadius(title) {
        switch (title) {
            case 'Tir':
                return 400;
            case 'Kidnapping':
                return 600;
            case 'Blocked':
                return 100;
            default:
                return 100;
        }
    }


    const userMarkerRef = useRef(null)




    const markersRef = useRef([]);
    const circlesRef = useRef([]);

    useEffect(() => {
        if (Array.isArray(alertMarker) && alertMarker.length > 0) {
            // Supprimez les anciens marqueurs et cercles
            markersRef.current.forEach(marker => marker.remove());
            circlesRef.current.forEach(circle => circle.remove());

            // Réinitialisez les tableaux
            markersRef.current = [];
            circlesRef.current = [];

            alertMarker.map((marker, index) => {
                if (marker.coordinate) {
                    const icon = getIcon(marker.title);
                    const markerInstance = L.marker([marker.coordinate.latitude, marker.coordinate.longitude], { icon }).addTo(map.current);
                    markerInstance.bindPopup(`${marker.title} - ${getTime(marker.createdAt)}`);

                    markerInstance.on('click', () => {
                        renderMarkerInfo(index);
                        map.current.flyTo([marker.coordinate.latitude, marker.coordinate.longitude], map.current.getZoom());
                    });

                    const circle = L.circle([marker.coordinate.latitude, marker.coordinate.longitude], {
                        radius: getRadius(marker.title),
                        fillColor: getColor(marker.title),
                        fillOpacity: 0.2,
                        color: getColor(marker.title)
                    }).addTo(map.current);

                    // Ajoutez les instances de marqueurs et de cercles aux tableaux
                    markersRef.current.push(markerInstance);
                    circlesRef.current.push(circle);
                }
            });
        }
    }, [alertMarker]);



    const renderMarkerInfo = async (markerIndex) => {
        setOpen(true)
        setCurrentMarkerIndex(markerIndex);
    };

     const socket = io(process.env.REACT_APP_SERVER_IP); 

    useEffect(() => {

    const requestAlerts = () => {
        socket.emit('requestAlerts');
    };

    socket.on('receiveAlerts', (alerts) => {
        setAlertMarker(alerts);
    });

    requestAlerts();

    const intervalId = setInterval(requestAlerts, 1000); 

    return () => {
        clearInterval(intervalId);
        socket.off('receiveAlerts');
    };
}, []);

    const fetchNearbyMarker = async () => {

        await axios.get(`${ServerIP}/alert/getAlert`)
            .then(res => {
                // console.log(res.data.alertMarker)
                setAlertMarker(res.data.alertMarker)
            })
    };


    const likeAlert = async (alertId) => {
        setIsVisible(true);

        const like = {
            userId: userId,
            alertId: alertId
        }

        await axios.patch(`${ServerIP}/alert/like`, like)
            .then(res => {
                console.log(res.data)

            })
            .catch(error => {
                console.log(error)

            })

        await fetchNearbyMarker();
        setIsVisible(false);

    }

    const dislikeAlert = async (alertId) => {
        setIsVisible(true);


        const dislike = {
            userId: userId,
            alertId: alertId
        }

        await axios.patch(`${ServerIP}/alert/dislike`, dislike)
            .then(res => {
                console.log(res.data)
            })
            .catch(error => {
                console.log(error)
            })

        await fetchNearbyMarker()
        setIsVisible(false);

    }

    const likeCommentary = async ({ alertId, commentId }) => {
        setIsVisible(true);


        const likeCommentary = {
            userId: userId,
            alertId: alertId,
            commentId: commentId
        }

        await axios.patch(`${ServerIP}/alert/likeCommentary`, likeCommentary)
            .then(res => {
                console.log(res.data)
            })
            .catch(error => {
                console.log(error)
            })

        await fetchNearbyMarker()
        setIsVisible(false);
    }

    const dislikeCommentary = async ({ alertId, commentId }) => {
        setIsVisible(true);

        const dislikeCommentary = {
            userId: userId,
            alertId: alertId,
            commentId: commentId
        }

        await axios.patch(`${ServerIP}/alert/dislikeCommentary`, dislikeCommentary)
            .then(res => {
                console.log(res.data)
            })
            .catch(error => {
                console.log(error)
            })

        await fetchNearbyMarker()
        setIsVisible(false);
    }

    const postCommentary = async (alertId) => {
        setIsVisible(true);
        const commentId = uuidv4();

        const postCommentary = {
            userId: userId,
            alertId,
            type: 'Driver',
            commentId: commentId,
            comment: commentary,
        }

        await axios.post(`${ServerIP}/alert/postCommentary`, postCommentary)
            .then(res => {
                setOpen2(false);
                console.log(res.data)
            })
            .catch(error => {
                if (error.response) {
                    setMessage(error.response.data.message);
                } else {
                    console.error("Error while making API request:", error);
                }
            })

        await fetchNearbyMarker();
        setIsVisible(false);

    }

    const deleteCommentary = async ({ alertId, commentId }) => {
        setIsVisible(true);

        const deleteCommentary = {
            userId: userId,
            alertId: alertId,
            commentId: commentId,
        }

        await axios.delete(`${ServerIP}/alert/deleteCommentary`, { data: deleteCommentary })
            .then(res => {
                console.log(res.data)
            })
            .catch(error => {
                console.log(error)
            })

        await fetchNearbyMarker()
        setIsVisible(false);

    }

    const reportCommentary = async ({ alertId, commentId }) => {
        setIsVisible(true);

        const reportCommentary = {
            userId: userId,
            alertId: alertId,
            commentId: commentId,
        }

        await axios.post(`${ServerIP}/alert/reportCommentary`, reportCommentary)
            .then(res => {
                console.log(res.data)
                setCommentId("")
            })
            .catch(error => {
                console.log(error)
            })

        await fetchNearbyMarker()
        setIsVisible(false);
    }

    const reportAlert = async ({ alertId }) => {
        setIsVisible(true);

        const reportAlert = {
            userId: userId,
            alertId: alertId,
        }

        await axios.post(`${ServerIP}/alert/reportAlert`, reportAlert)
            .then(res => {
                console.log(res.data)
            })
            .catch(error => {
                console.log(error)
            })

        await fetchNearbyMarker()
        setIsVisible(false);
    }


    const closeModal = () => {
        if (isOpen2 === false) {
            setCommentary("");
            setCurrentMarkerIndex(null);
            setOpen(false)
        }
    }

    const closeModal1 = () => {
        setOpen1(false)
    }

    const closeModal2 = () => {
        setOpen2(false)
    }



    if (!cache.current) {
        cache.current = new CellMeasurerCache({
            fixedWidth: true,
            defaultHeight: 50
        });
    }

    const getTime = (time) => {
        var date = new Date(time);
        var maintenant = new Date();
        var difference = Math.abs(maintenant - date); // en millisecondes

        var minutes = Math.floor(difference / 60000);
        if (minutes < 60) {
            return minutes + " min";
        } else {
            var heures = Math.floor(minutes / 60);
            return heures + " h";
        }

    }

    const [showModal, setShowModal] = useState(false)
    const [commentId, setCommentId] = useState('')

    const handleReport = () => {
        if (commentId !== '') {
            reportCommentary({
                commentId: commentId,
                alertId: alertMarker[currentMarkerIndex].alertId
            })
        } else {
            reportAlert({
                alertId: alertMarker[currentMarkerIndex].alertId
            })
        }

        setShowModal(false)
    };


    const firstCallRef = useRef(true);
    const [isPressed, setIsPressed] = useState(false);

    useEffect(() => {

        intervalIdRef.current = setInterval(getRealTimePosition, 5000);

        return () => {
            if (intervalIdRef.current) {
                clearInterval(intervalIdRef.current);
            }
        };

    }, []);

    const getRealTimePositionFunc = async () => {
        intervalIdRef.current = setInterval(getRealTimePosition, 5000);


        if (location.length !== 0 && !map.current.getCenter().equals([location[0], location[1]]) && firstCallRef.current === false) {
            map.current.flyTo([location[0], location[1]], map.current.getZoom());
        }

    }

    const getRealTimePosition = async () => {
        try {
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, { maximumAge: 5000 });
            });

            const { latitude, longitude } = position.coords;

            setLocation([latitude, longitude]);

            const userIcon = L.icon({
                iconUrl: require('../data/IconImageMap/currentLocation.png'),
                iconSize: [25, 36],
                iconAnchor: [12, 36],
            });

            if (!userMarkerRef.current) {
                userMarkerRef.current = L.marker([latitude, longitude], { icon: userIcon }).addTo(map.current);
            } else {
                userMarkerRef.current.setLatLng([latitude, longitude]);
            }


            if (firstCallRef.current === true) {
                map.current.flyTo([latitude, longitude], map.current.getZoom());
                firstCallRef.current = false;
            }


        } catch (error) {
            console.error('Erreur de géolocalisation:', error);
        }
    };

    return (


        <div className="map-wrap">


            <div style={{ position: 'absolute', width: '100%', height: '100%' }}>
                {addMarker ? (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            right: 25,
                            top: 30,
                            zIndex: 1,
                            borderWidth: '1px',
                            backgroundColor: colors.gray2,
                            height: 50,
                            width: 50,
                            borderRadius: '50%',
                            boxShadow: '0 0 10px #fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        onClick={cancelMarkerFunc}
                    >
                        <EnvironmentFilled style={{ color: colors.black }} />
                        <CloseOutlined style={{ color: colors.black, marginLeft: '5px', fontSize: '12px' }} />
                    </div>

                ) : (
                    <>
                        {location.length !== 0 && (
                            <div
                                style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    right: 25,
                                    top: 30,
                                    zIndex: 1,
                                    borderWidth: '1px',
                                    backgroundColor: colors.gray2,
                                    height: 50,
                                    width: 50,
                                    borderRadius: '50%',
                                    boxShadow: '0 0 10px #f0f0f0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                onClick={setMarkerFunc}
                            >
                                <EnvironmentFilled style={{ color: colors.black }} />
                                <PlusOutlined style={{ color: colors.black, marginLeft: '5px', fontSize: '12px' }} />
                            </div>
                        )}
                    </>
                )}

                {addMarker === true && (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            right: 25,
                            top: 100,
                            zIndex: 1,
                            borderWidth: '1px',
                            backgroundColor: colors.accent,
                            height: 50,
                            width: 50,
                            borderRadius: '50%',
                            boxShadow: '0 0 10px #f0f0f0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        onClick={confirmMarkerFunc}
                    >
                        <EnvironmentFilled style={{ color: colors.black }} />
                        <CheckOutlined style={{ color: colors.black, marginLeft: '5px', fontSize: '12px' }} />
                    </div>
                )}

                <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        right: '3%',
                        top: '66%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1,
                        borderWidth: '1px',
                        backgroundColor: isPressed ? colors.white : colors.accent,
                        height: 50,
                        width: 50,
                        borderRadius: '50%',
                        display: 'flex',
                        alignSelf: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'transform 0.1s, background-color 0.1s',
                        transform: isPressed ? 'scale(0.95)' : 'scale(1)',
                    }}
                    onMouseDown={() => setIsPressed(true)}
                    onMouseUp={() => setIsPressed(false)}
                    onMouseLeave={() => setIsPressed(false)}
                    onTouchStart={() => setIsPressed(true)}
                    onTouchEnd={() => setIsPressed(false)}
                    onTouchCancel={() => setIsPressed(false)}
                    onClick={getRealTimePositionFunc}
                >
                    <FaCrosshairs size={20} color={colors.black} />
                </div>

                <div
                    style={{
                        position: 'absolute',
                        alignSelf: 'center',
                        justifySelf: 'center',
                        bottom: 0,
                        top: 0,
                        right: 0,
                        left: 0,
                        zIndex: 1,
                        height: 50,
                        width: 50,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <PlusOutlined style={{ color: colors.black, marginLeft: '5px', fontSize: '12px' }} />
                </div>

            </div>


            <div ref={mapContainer} className="map" style={{ zIndex: 0 }} />


            <Sheet
                isOpen={isOpen}
                onClose={closeModal}
                snapPoints={[900]}
            >
                <Sheet.Container>
                    <Sheet.Header />
                    <Sheet.Content>


                        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

                            <Loader visible={isVisible} />


                            <div style={{ alignSelf: 'flex-end', marginRight: '25px' }}>
                                <div style={{ height: '23px', width: '23px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    onClick={closeModal}>

                                    {isOpen2 === false && <FontAwesomeIcon icon={faClose} size="lg" />}
                                </div>
                            </div>

                            {showModal && (
                                <>
                                    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'black', opacity: 0.2, zIndex: 999 }}></div>

                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: '#fff', padding: '20px', borderRadius: '10px', zIndex: 1000, width: '60%' }}>

                                        <h2 style={{ fontSize: '20px', fontWeight: 700, fontFamily:'Inter' }}>Confirmation</h2>
                                        <span style={{ fontSize: '15px', fontWeight: 700, fontFamily:'Inter', marginBottom: '20px' }}>Êtes-vous sûr de vouloir signaler ?</span>

                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                            <div onClick={() => { setShowModal(false); setCommentId("") }} style={{
                                                backgroundColor: colors.gray2, color: colors.black, fontSize: '14px',
                                                fontWeight: 700, fontFamily:'Inter', padding: '10px', borderRadius: '35px', cursor: 'pointer', marginRight: '10px', width: 80, display: 'flex', alignItems: 'center', justifyContent: 'center'
                                            }}>Non</div>
                                            <div onClick={handleReport} style={{
                                                color: colors.black, fontSize: '14px', marginLeft: '10px', width: 80, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                fontWeight:700, fontFamily:'Inter', backgroundColor: colors.accent, padding: '10px', borderRadius: '35px', cursor: 'pointer'
                                            }}>Oui</div>
                                        </div>

                                    </div>
                                </>
                            )}


                            {currentMarkerIndex !== null && (
                                <>
                                    <div style={{ display: 'flex', flexDirection: 'column', padding: '20px', height: '100%' }}>
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
                                                <p style={{ fontSize: '17px', fontWeight: 700, fontFamily:'Inter' }}>{alertMarker[currentMarkerIndex].title}</p>
                                                <p style={{ fontSize: '13px', fontWeight: 400, fontFamily:'Inter' }}>Il y a {getTime(alertMarker[currentMarkerIndex].createdAt)}</p>
                                            </div>
                                            {alertMarker[currentMarkerIndex].reportHistory.some(item => item.userId === userId) ?
                                                <span style={{ fontSize: '15px', fontWeight: 700, fontFamily:'Inter', color: colors.gray }}>Signaler</span>
                                                :
                                                <FaExclamationTriangle onClick={() => { setShowModal(true) }} size={'20px'} style={{ color: 'gray', marginRight: '10px' }} />
                                            }
                                        </div>


                                        {alertMarker[currentMarkerIndex].description.length !== 0 && (
                                            <div>
                                                <span style={{ fontWeight: 700, fontFamily:'Inter', fontSize: '15px' }}>Description</span>
                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '2px', marginBottom: '5px' }}>
                                                    <p style={{ fontSize: '13px', fontWeight: 700 , fontFamily:'Inter', color: 'gray' }}>{alertMarker[currentMarkerIndex].description}</p>
                                                </div>
                                            </div>
                                        )}



                                        <div style={{ display: 'flex', flexDirection: 'row', backgroundColor: colors.gray2, borderRadius: '15px', marginTop: '10px', height: '30px', width: '30%', alignItems: 'center' }}>
                                            <div
                                                onClick={() => { likeAlert(alertMarker[currentMarkerIndex].alertId) }}
                                                style={{ marginLeft: '5px', marginRight: '0px', gap: '10px', height: '20px', width: '44%', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>
                                                {alertMarker[currentMarkerIndex].likes.some(item => item === userId) ? (
                                                    <LikeFilled style={{ bottom: '1px', color: 'gray' }} />
                                                ) : (
                                                    <LikeOutlined style={{ bottom: '1px', color: 'black' }} />
                                                )}
                                                <p style={{ fontSize: '13px', fontWeight: 400, fontFamily:'Inter' }}>{alertMarker[currentMarkerIndex].likes.length}</p>
                                            </div>

                                            <p style={{ color: 'gray' }}>｜</p>

                                            <div
                                                onClick={() => { dislikeAlert(alertMarker[currentMarkerIndex].alertId) }}
                                                style={{ marginRight: '5px', marginLeft: '0px', gap: '10px', height: '20px', width: '44%', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>
                                                <p style={{ fontSize: '13px', fontWeight: 400, fontFamily:'Inter' }}>{alertMarker[currentMarkerIndex].dislikes.length}</p>

                                                {alertMarker[currentMarkerIndex].dislikes.some(item => item === userId) ? (
                                                    <DislikeFilled style={{ top: '1px', transform: 'scaleX(-1)', color: 'gray' }} />
                                                ) : (
                                                    <DislikeOutlined style={{ top: '1px', transform: 'scaleX(-1)', color: 'black' }} />
                                                )}

                                            </div>
                                        </div>

                                        <p style={{ marginTop: '20px', fontSize: '16px', fontWeight: 700, fontFamily:'Inter' }}>Commentaire</p>



                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px', marginVertical: '10px' }}>
                                            <div
                                                onClick={() => {
                                                    setCommentaryType("");
                                                    setCommentaryType("Popile")
                                                }}
                                                style={{
                                                    backgroundColor: colors.gray2,
                                                    height: '30px',
                                                    width: '25%',
                                                    borderRadius: '5px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    ...(commentaryType === "Popile" && {
                                                        backgroundColor: colors.accent
                                                    })
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        fontSize: '14px',
                                                        fontWeight: 700, fontFamily:'Inter',
                                                        ...(commentaryType === "Popile" && {
                                                            color: colors.black
                                                        })
                                                    }}
                                                >Populaire</p>
                                            </div>

                                            <div
                                                onClick={() => {
                                                    setCommentaryType("");
                                                    setCommentaryType("Resan");
                                                }}
                                                style={{
                                                    backgroundColor: colors.gray2,
                                                    height: '30px',
                                                    width: '25%',
                                                    borderRadius: '5px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    ...(commentaryType === "Resan" && {
                                                        backgroundColor: colors.accent
                                                    })
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        fontSize: '14px',
                                                        fontWeight: 700, fontFamily:'Inter',
                                                        ...(commentaryType === "Resan" && {
                                                            color: colors.black
                                                        })
                                                    }}
                                                >
                                                    Recent
                                                </p>
                                            </div>

                                        </div>



                                        <hr style={{ borderWidth: '0.1px', borderColor: colors.gray2, margin: '10px 0' }} />

                                        {alertMarker[currentMarkerIndex].commentary.length === 0 && (
                                            <div style={{ padding: '20px', height: '46%' }}>
                                                <div style={{ margin: '30px 0', textAlign: 'center' }}>
                                                    <p style={{ fontSize: '16px', fontWeight: 700, fontFamily:'Inter' }}>Aucun commentaires</p>
                                                    <p style={{ fontSize: '14px', fontWeight: 400, fontFamily:'Inter' }}>Soyez le premier à commenter</p>
                                                </div>
                                            </div>
                                        )}

                                        {alertMarker[currentMarkerIndex].commentary.length !== 0 && (
                                            <div style={{ height: '60%', display: 'flex' }}>
                                                <AutoSizer>

                                                    {({ width, height }) => (

                                                        <List
                                                            ref={listRef}
                                                            width={width}
                                                            height={height}
                                                            rowCount={alertMarker[currentMarkerIndex].commentary.length}
                                                            deferredMeasurementCache={cache.current}
                                                            rowHeight={cache.current.rowHeight}
                                                            rowRenderer={({ index, key, parent, style }) => {

                                                                // const commentaryCopy = [...alertMarker[currentMarkerIndex].commentary];
                                                                // let sortedCommentary;

                                                                // if (commentaryType === "Resan") {
                                                                //     sortedCommentary = commentaryCopy.sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt));
                                                                // }
                                                                // if (commentaryType === "Popile") {
                                                                //     sortedCommentary = commentaryCopy.sort((a, b) => b.likes.length - a.likes.length);
                                                                // }

                                                                const commentaryCopy = [...alertMarker[currentMarkerIndex].commentary];
                                                                const originalCommentary = [...commentaryCopy]; // Copie des commentaires dans leur ordre d'origine
                                                                let sortedCommentary;

                                                                // Trier les commentaires selon le type de tri
                                                                if (commentaryType === "Resan") {
                                                                    sortedCommentary = commentaryCopy.sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt));
                                                                } else if (commentaryType === "Popile") {
                                                                    sortedCommentary = commentaryCopy.sort((a, b) => b.likes.length - a.likes.length);
                                                                }

                                                                // Mettre en avant vos commentaires
                                                                const yourComments = sortedCommentary.filter(comment => comment.userId === userId); // Remplacez 'VotreNom' par votre nom d'utilisateur
                                                                const otherComments = sortedCommentary.filter(comment => comment.userId !== userId);

                                                                // Combiner vos commentaires en tête et les autres commentaires ensuite
                                                                const finalSortedCommentary = [...yourComments, ...otherComments];


                                                                const item = finalSortedCommentary[index];

                                                                const { alertId } = alertMarker[currentMarkerIndex];


                                                                const handleDelete = () => {
                                                                    deleteCommentary({ alertId, commentId: item.commentId });
                                                                };

                                                                const handleLike = () => {
                                                                    likeCommentary({ alertId, commentId: item.commentId });
                                                                };

                                                                const handleDislike = () => {
                                                                    dislikeCommentary({ alertId, commentId: item.commentId });
                                                                };

                                                                return (
                                                                    <CellMeasurer
                                                                        key={key}
                                                                        cache={cache.current}
                                                                        parent={parent}
                                                                        columnIndex={0}
                                                                        rowIndex={index}
                                                                    >
                                                                        {({ measure }) => (
                                                                            <div onLoad={measure} style={style}>

                                                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>

                                                                                    <div style={{ display: 'flex', flexDirection: 'row', gap: 5 }}>
                                                                                        <span style={{ color: 'gray', fontSize: '13px', fontWeight: 400, fontFamily:'Inter' }}>
                                                                                            @{item.name.length <= 3 ? item.name : item.name.substring(0, 3) + '***'}
                                                                                        </span>

                                                                                        <span style={{ color: 'gray', fontSize: '13px', paddingLeft: '5px', paddingRight: '5px', fontWeight: 400, fontFamily:'Inter', border: '0.5px solid #907EFF' }}>
                                                                                            {item.type}
                                                                                        </span>

                                                                                    </div>

                                                                                    <span style={{ color: 'gray', fontSize: '13px', fontWeight: 400, fontFamily:'Inter' }}>Il y a {getTime(item.createdAt)}</span>

                                                                                    {item.userId === userId ? (
                                                                                        <div
                                                                                            onClick={handleDelete}
                                                                                            style={{ borderRadius: '300px', height: '25px', width: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                                                        >
                                                                                            <FaTrash size={'13px'} style={{ color: 'gray', marginRight: '10px' }} />
                                                                                        </div>
                                                                                    ) : (
                                                                                        <>
                                                                                            {item.reportHistory.some(item => item.userId === userId) ?
                                                                                                <span style={{ fontSize: '15px', fontWeight: 700, fontFamily:'Inter', color: colors.gray }}>Signaler</span>
                                                                                                :
                                                                                                <div
                                                                                                    onClick={() => { setShowModal(true); setCommentId(item.commentId) }}

                                                                                                    style={{ borderRadius: '300px', height: '25px', width: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                                                                >
                                                                                                    <FaExclamationTriangle size={'20px'} style={{ color: 'gray', marginRight: '10px' }} />
                                                                                                </div>
                                                                                            }
                                                                                        </>
                                                                                    )}


                                                                                </div>


                                                                                <div style={{ marginTop: '3px', marginLeft: '10px' }}>
                                                                                    <span style={{ color: colors.black, fontSize: '14px', fontWeight: 700, fontFamily:'Inter' }}>{item.comment}</span>
                                                                                </div>

                                                                                <div style={{ display: 'flex', alignItems: 'center', width: '33%', gap: '13px', marginTop: '7px' }}>
                                                                                    <div
                                                                                        onClick={handleLike}
                                                                                        style={{ left: 0, gap: '10px', height: '30px', width: '44%', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                        {item.likes.some(item => item === userId) ? (
                                                                                            <LikeFilled style={{ bottom: '1px', color: colors.gray }} />
                                                                                        ) : (
                                                                                            <LikeOutlined style={{ bottom: '1px', color: 'black' }} />
                                                                                        )}
                                                                                        <span style={{ fontSize: '12px', fontWeight: 400, fontFamily:'Inter', color: colors.black }}>{item.likes.length}</span>
                                                                                    </div>
                                                                                    <div
                                                                                        onClick={handleDislike}
                                                                                        style={{ right: 0, gap: '10px', height: '30px', width: '44%', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                        <span style={{ fontSize: '12px', fontWeight: 400 , fontFamily:'Inter', color: colors.black }}>{item.dislikes.length}</span>
                                                                                        {item.dislikes.some(item => item === userId) ? (
                                                                                            <DislikeFilled style={{ top: '1px', transform: 'scaleX(-1)', color: colors.gray }} />
                                                                                        ) : (
                                                                                            <DislikeOutlined style={{ top: '1px', transform: 'scaleX(-1)', color: 'black' }} />
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                                <hr style={{ borderWidth: '0.5px', borderColor: colors.gray2, margin: '15px 0' }} />



                                                                            </div>
                                                                        )}
                                                                    </CellMeasurer>
                                                                );
                                                            }}
                                                        />
                                                    )}
                                                </AutoSizer>
                                            </div>
                                        )}

                                    </div>
                                </>
                            )}


                            <div style={{ display: 'flex', alignItems: 'center', height: '10%', backgroundColor: 'white' }}>

                                <div onClick={(event) => {
                                    console.log("pressed");
                                    setOpen2(true);
                                    event.stopPropagation();
                                }}
                                    style={{ width: '91%', height: '45px', display: 'flex', borderRadius: '5px', alignItems: 'center', marginLeft: '20px', backgroundColor: colors.gray2 }}>

                                    <span style={{ fontSize: '14px', width: '95%', fontWeight: 700, fontFamily:'Inter', color: 'gray', marginLeft: '10px', wordWrap: 'break-word' }}>
                                        {commentary === '' ? 'Ajoutez un commentaire...' : (commentary.length > 100 ? commentary.substring(0, 110) + '...' : commentary)}
                                    </span>

                                </div>

                            </div>

                        </div>

                    </Sheet.Content>


                </Sheet.Container>
                <Sheet.Backdrop />
            </Sheet>

            <Sheet
                isOpen={isOpen2}
                onClose={closeModal2}
                snapPoints={[200]}
            >
                <Sheet.Container>
                    <Sheet.Header />
                    <Sheet.Content>
                        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>


                            <div style={{ display: 'flex', alignItems: 'center', height: '50%', backgroundColor: 'white' }}>

                                <textarea
                                    type="text"
                                    value={commentary}
                                    onChange={(e) => setCommentary(e.target.value)}
                                    placeholder='Ajoutez un commentaire...'
                                    style={{
                                        width: '79%', height: '45px', marginLeft: '20px', backgroundColor: colors.gray2, bottom: '10px', outlineColor: colors.accent,
                                        boxShadow: 'none', fontWeight: 'bold'
                                    }}
                                />

                                <div
                                    onClick={() => {
                                        postCommentary({
                                            alertId: alertMarker[currentMarkerIndex].alertId
                                        });
                                        setCommentary("");
                                    }}
                                    style={{ width: '10%', height: '45px', marginLeft: '5px', backgroundColor: colors.gray2, bottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                >
                                    <img src={require('../data/IconImageMap/Send.png')} alt='Send' style={{ height: '23px', width: '23px' }} />
                                </div>

                            </div>

                        </div>
                    </Sheet.Content>
                </Sheet.Container>
            </Sheet>

            <Sheet
                isOpen={isOpen1}
                onClose={closeModal1}
                snapPoints={[800]}
            >
                <Sheet.Container>
                    <Sheet.Header />
                    <Sheet.Content>
                        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                            <div style={{ alignSelf: 'flex-end', marginRight: '25px' }}>
                                <div style={{ height: '23px', width: '23px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    onClick={closeModal1}>

                                    <FontAwesomeIcon icon={faClose} size="lg" />
                                </div>
                            </div>

                            {/* Mapping des états pour créer les boutons */}
                            <div style={{ margin: '20px', flexDirection: 'row', display: 'flex' }}>
                                {states.map((item, index) => (
                                    <div key={index}
                                        style={{
                                            backgroundColor: selectedState === item ? colors.accent : colors.gray2,
                                            height: '30px',
                                            width: '85px',
                                            padding: '10px',
                                            marginLeft: '10px',
                                            borderRadius: '10px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                        onClick={() => setSelectedState(item)}>
                                        <span style={{
                                            color: selectedState === item ? colors.black : colors.black,
                                            fontSize: '15px',
                                            fontWeight: 700, fontFamily:'Inter'
                                        }}>{item}
                                        </span>
                                    </div>
                                ))}
                            </div>


                            {/* Ajout d'un champ de saisie pour ajouter une description */}
                            <div style={{ margin: '20px', width: '88%', height: '10vh' }}>
                                <textarea
                                    style={{ width: '100%', height: '100%' }}
                                    placeholder="Ajoutez une description ici"
                                    maxLength={200}
                                    onChange={e => {
                                        setDescription(e.target.value);
                                    }}
                                />
                            </div>


                            {(message) && <ErrorComponent errorMessage={message} />}


                            {/* Ajout d'un bouton de confirmation en bas */}
                            <div style={{ margin: '20px', }}>
                                <div
                                    style={{
                                        width: '100%',
                                        height: '55px',
                                        backgroundColor: colors.accent,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        display: 'flex',
                                        borderRadius: '35px',
                                    }}
                                    onClick={confirmAction}>
                                    <span style={{ fontSize: '16px', fontWeight:700, fontFamily:'Inter', color: colors.black }}>Confirmer</span>
                                </div>
                            </div>

                        </div>
                    </Sheet.Content>
                </Sheet.Container>
            </Sheet>

        </div >

    )
}

export default AlertDriverMap;


